import { render, staticRenderFns } from "./PredictionSummaryDialog.vue?vue&type=template&id=0fb952e2&scoped=true"
import script from "./PredictionSummaryDialog.vue?vue&type=script&lang=ts"
export * from "./PredictionSummaryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb952e2",
  null
  
)

export default component.exports